import { ACTIONS } from "./names";
import { ACTIONS as COMMISSIONS_INFO_ACTIONS } from "./info/names";

export default {
    [ACTIONS.CLEAR_COMMISSIONS_STATE]({ dispatch }) {
        dispatch(`affility/user/binary/commissions/info/${COMMISSIONS_INFO_ACTIONS.CLEAR_COMMISSIONS_INFO_STATE}`, null, { root: true });  
    },
};